export const SUBSCRIPTION_BLOCKED_MESSAGE =
  'Your current subscription plan does not support this feature. Please upgrade to a paid plan to access it.';

export const PREMIUM_FEATURE_ONLY_MESSAGE =
  'This feature is available only for existing Premium users.';

export function isPocTenant() {
  try {
    const profile = JSON.parse(localStorage.getItem('profile') || '{}');
    return String(profile?.tenantType || '').toUpperCase() === 'POC';
  } catch {
    return false;
  }
}

export function isSubscriptionBlockedError(message) {
  if (!message) return false;
  const m = String(message).toLowerCase();
  return (
    m.includes('subscription plan does not support') ||
    m.includes('upgrade to a paid plan') ||
    m.includes('does not support this feature')
  );
}
